"use client";
import React, {useEffect} from "react";

import {getUrl} from "provider/magento/utilities";


import {useCommerceContext} from "provider/magento/context";
import XCircleIcon from "@heroicons/react/24/outline/XCircleIcon";
import NFLink from "app/components/NFLink/NFLink";
import Button from "app/components/Button/Button";
import ArrowRightIcon from "@heroicons/react/16/solid/ArrowRightIcon";

import {Loader} from "../Loader/Loader";
import CartItem from "./CartItem";
import {usePhrase} from "../../i18n";
import {formatCurrencySymbol, formatPriceStyle} from "../../utilities/price";
import ShoppingCartIcon from "@heroicons/react/16/solid/ShoppingCartIcon";
import {sendGTMEvent} from "@next/third-parties/google";

const RightSidebar = ({store, isOpen, closeSidebar, storeCode, _t}) => {


    const {cart, isLoadingCart} = useCommerceContext();

    const t = usePhrase(_t);

    useEffect(() => {
        if (isOpen) {
            if (document) {
                document.getElementsByTagName('html')[0].style.overflow = 'hidden';
            }
        } else {
            if (document) {
                document.getElementsByTagName('html')[0].style.overflow = 'auto';
            }
        }
    }, [isOpen]);


    useEffect(() => {


        setTimeout(() => {
            if (window && document && !isOpen) {
                let el = document.getElementById('cart-sidebar');

                if (el) {
                    let isVisible = elementIsVisibleInViewport(el);
                    if (isVisible) {
                        console.log('Cart sidebar is visible');
                        sendGTMEvent({
                            event: 'cart_sidebar_init_visible',
                            storeView: storeCode
                        });
                    } else {
                        //console.log('Cart sidebar is not visible');
                    }
                }

            } else {
                console.warn(`DOM is not available`);
            }
        }, 1000);

    });


    const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
        const {top, left, bottom, right} = el.getBoundingClientRect();
        const {innerHeight, innerWidth} = window;
        return partiallyVisible
            ? ((top > 0 && top < innerHeight) ||
                (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
            : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    };

    return <>
        {isOpen &&
            <div
                className="fixed inset-0 z-[60] bg-gray-500/75 h-full w-full transition-opacity cursor-pointer"
                aria-hidden="true" onClick={closeSidebar}></div>}

        <div id={`cart-sidebar`} className={"fixed top-0 right-0 inset-y-0 max-w-full h-full flex overflow-hidden z-[70] ease-in-out duration-300 " + (isOpen ? 'translate-x-0' : ' translate-x-full')}

        >

            <div className="w-screen max-w-md  flex flex-col bg-white shadow-xl">

                <div className="py-3 px-4 sm:px-6 bg-gray-100">
                    <div className="flex items-center justify-between">
                        <h2 className="text-base font-bold text-gray-900" id="slide-over-title">
                            {t('Shopping cart')} {cart && <>({cart?.items_qty ?? 0} {t('items')})</>}
                        </h2>
                        <div className=" flex items-center">
                            <button aria-label={t('Close sidebar')} type="button"
                                    className="text-gray-400 hover:text-gray-500" onClick={closeSidebar}>
                                <span><XCircleIcon className={'h-6 w-6'}/></span>
                            </button>
                        </div>
                    </div>


                </div>


                <div className={` relative flex-1 overflow-y-auto z-10`}>
                    <div className="h-full py-1 px-2 sm:px-6  overflow-y-auto ">
                        {cart && <>
                            {cart && cart.items && cart.items.length > 0 ?
                                <ul role="list" className={`divide-y`}>
                                    {cart.items.map((i, idx) =>
                                        <CartItem key={'cart_item_box_' + i.item_id + '_' + i.qty} item={i}
                                                  store={store}
                                                  _t={_t}/>
                                    )}
                                </ul> : <div className={`h-full flex flex-col justify-center items-center`}>
                                    <ShoppingCartIcon className={'h-20 w-20 mx-auto text-gray-300'}/>
                                    <p className={`text-xl text-gray-300`}>{t('No items')}</p>
                                </div>}
                        </>}
                        {!cart && !isLoadingCart &&
                            <div className={`h-full flex flex-col justify-center items-center`}>
                                <ShoppingCartIcon className={'h-20 w-20 mx-auto text-gray-300'}/>
                                <p className={`text-xl text-gray-300`}>{t('No items')}</p>
                            </div>}
                    </div>

                    {(isLoadingCart) && <div
                        className={`bg-[#00000007] top-0 left-0 block absolute w-full h-full flex justify-center items-center`}>
                        <Loader className={`py-0`} iconClassName={`!h-10 !w-10 !m-0`}/>
                    </div>}
                </div>

                <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                    <div className="flex justify-between text-xl font-bold text-gray-900">
                        <div>
                            <p className={'uppercase py-1'}>{t('Subtotal')}</p>
                        </div>
                        <div className={`flex items-center justify-center`}>

                            {!isLoadingCart ? <span className={'text-xl font-bold'}>
                                {formatPriceStyle(parseFloat(cart?.totals?.subtotal_incl_tax || '0.00').toFixed(2), true)}
                                <span
                                    className={`ml-1`}>{formatCurrencySymbol(store?.default_display_currency_code)}</span>
                                    </span> : <Loader className={`!py-0`} iconClassName={`!h-6 !w-6 !m-0`}/>}

                        </div>
                    </div>
                    <div className="mt-6">
                        <NFLink storeCode={storeCode}
                                href={getUrl(`${store.secure_base_link_url}checkout/cart`, storeCode)}>
                            <Button
                                id="go_to_cart_button"
                                aria-label={t('Go to Cart')}
                                className={`${(isLoadingCart || !cart || (cart && cart?.items_qty === 0)) ? 'disabled' : ''} flex items-center justify-center relative`}
                                disabled={isLoadingCart || !cart || (cart && cart?.items_qty === 0)}
                                onClick={closeSidebar}>
                                <span>{t('Go to Cart')}</span>
                                <span className={'absolute right-2'}><ArrowRightIcon className={'h-5 w-5 '}/></span>
                            </Button>
                        </NFLink>
                    </div>
                    <div className="mt-1 flex justify-center text-sm text-center text-gray-500">
                        <Button aria-label={t('Continue Shopping')} white
                                className={'flex items-center justify-center relative'} onClick={closeSidebar}>
                            <span>{t('Continue Shopping')}</span>
                            <span className={'absolute right-2'}><ArrowRightIcon className={'h-5 w-5 '}/></span>
                        </Button>
                    </div>

                </div>
            </div>
        </div>
    </>;

}

export default RightSidebar;